export const cookiesOLP = {
  olp_sidebar: 'olp_sidebar',
  olp_search_transfer_balance_filter: 'olp_search_transfer_balance_filter',
  olp_search_invoices_filter: 'olp_search_invoices_filter',
  olp_search_orders_filter: 'olp_search_orders_filter',
  olp_search_users_filter: 'olp_search_users_filter',
  olp_search_customers_filter: 'olp_search_customers_filter',
  olp_search_campaigns_filter: 'olp_search_campaigns_filter',
  olp_search_status_card_filter: 'olp_search_status_card_filter',
  olp_token: 'olp_token',
  olp_expire_token: 'olp_expire_token',
  olp_user_uuid: 'olp_user_uuid',
  olp_company_uuid: 'olp_company_uuid',
  olp_first_access: 'olp_first_access',
  olp_tenant_id: 'olp_tenant_id',
  olp_remember_me: 'olp_remember_me',
  olp_saved_login_user: 'olp_saved_login_user',
  olp_breadcrumbs: 'olp_breadcrumbs',
  olp_user_informations: 'olp_user_informations',
}
